<template>
  <div class="page">
    <!-- 筛选条 -->
    <section class="toolbar">
      <div class="tabs">
        <select v-model="stream_name" @change="streamChange">
          <option v-for="s in streamLists" :value="s.stream_name" :start-time="s.start_time">{{ s.stream_name }}</option>
        </select>
        <button
          class="tab"
          :class="{ active: mode==='realtime' }"
          @click="switchMode('realtime')"
        >实时</button>
        <button
          class="tab"
          :class="{ active: mode==='range' }"
          @click="switchMode('range')"
        >区间</button>
      </div>
      <div v-if="mode==='realtime'" class="realtime">
        <span class="dot" :class="{ on: ticking }"></span>
        <span class="txt">自动刷新：每 {{ autoInterval }}s</span>
        <button class="btn" @click="emitFilterNow">立即刷新</button>
      </div>

      <div v-else class="range">
        <label class="field">
          <span>开始</span>
          <input type="datetime-local" v-model="start" @change="onRangeChange">
        </label>
        <label class="field">
          <span>结束</span>
          <input type="datetime-local" v-model="end" @change="onRangeChange">
        </label>
        <button class="btn" @click="emitFilterNow">查询</button>
      </div>
    </section>
    <slot></slot>
    <!-- 表格 -->
    <section class="table-wrap">
      <table class="table">
        <thead>
          <tr>
            <th style="min-width:84px;">用户</th>
            <th style="min-width:140px;">进入网页时间</th>
            <th style="min-width:90px;">地区</th>
            <th style="min-width:100px;">来源</th>
            <th style="min-width:120px;">拉流成功</th>
            <th style="min-width:120px;">拉流成功时间</th>
            <th style="min-width:140px;">弹幕加载成功</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="[k,r] in rows" :key="r.id || r.user + r.time">
            <td class="cell-user">
              <span class="uid">{{ k }}</span>
            </td>
            <td class="cell-time">
              <span>{{ r.first_open|| '-' }}</span>
            </td>
            <td>{{ r.city || '-' }}</td>
            <td>{{ r.source | filterSource}}</td>
            <td class="cell-flag">
              <i :class="r.first_play ? 'ok' : 'no'">{{ r.first_play ? '✅' : '✖️' }}</i>
            </td>
            <td class="cell-flag">
              <!-- <span>{{ (r.first_play_time - r.first_open_time || 0) / 1000 + 's' }}</span> -->
              <span>{{ r.first_play_time }}</span>
            </td>
            <td class="cell-flag">
              <i :class="r.first_load_danmu ? 'ok' : 'no'">{{ r.first_load_danmu ? '✅' : '✖️' }}</i>
            </td>
          </tr>
          <tr v-if="!rows || !rows.length">
            <td colspan="7" class="empty">暂无数据</td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
import { liveroomsList } from '@/api';

/**
 * MobileStreamTable.vue (Vue 2)
 * Props:
 *  - rows: Array<{ id?, user, time, city, source/http, enter, pull, danmaku }>
 *  - autoInterval: Number 实时模式轮询间隔（秒），默认 10
 * Emits:
 *  - filter({ mode, start, end }): 用户点击“查询/立即刷新”
 *  - tick(): 实时模式每 autoInterval 秒触发一次（可在外部重新拉数据）
 */
export default {
  name: 'MobileStreamTable',
  props: {
    rows: { type: Array, default: () => [] },
    autoInterval: { type: Number, default: 10 }
  },
  data() {
    return {
      mode: 'realtime',   // 'realtime' | 'range'
      start: '',
      end: '',
      timer: null,
      ticking: false,
      streamLists:[],
      stream_name:null,
      stream_start_time:null
    }
  },
  async mounted() {
    await this.getliveroomsList()
    await this.startTick()
  },
  beforeDestroy() {
    this.stopTick()
  },
  filters:{
    filterSource(value) {
      let f_context = {
        platform:value.utm_source || '',
        title:value.utm_campaign || ''
      }
      let text = ''
      for(const k in f_context){
        console.log(k)
        let keyname = {
          platform:'平台',
          title:'广告标题'
        }
        if(!f_context[k]) return
        text += `
        ${keyname[k]}:${f_context[k]}
        `
      }
      return  text
    }
  },
  methods: {
    async getliveroomsList(){
      let { data } = await liveroomsList()
      this.streamLists = data.data
      this.stream_name = this.streamLists[0].stream_name
      this.stream_start_time = this.streamLists[0].time_on
      this.start = this.stream_start_time
    },
    streamChange(e){
      console.log(this.streamLists.find(f => f.stream_name == this.stream_name))
      this.stream_start_time = this.streamLists.find(f => f.stream_name == this.stream_name).time_on
      this.start = this.stream_start_time
      this.emitFilterNow()
    },
    formatTime(t) {
      // 支持传入时间戳/ISO/字符串
      try {
        const d = typeof t === 'number' ? new Date(t) : new Date(String(t))
        if (isNaN(d.getTime())) return String(t || '-')
        const pad = (n) => n < 10 ? '0'+n : n
        return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ` +
               `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
      } catch (e) { return String(t || '-') }
    },
    switchMode(m) {
      if (this.mode === m) return
      this.mode = m
      if (m === 'realtime') this.startTick()
      else this.stopTick()
    },
    onRangeChange() {
      // 可加入开始时间 <= 结束时间的校验
    },
    emitFilterNow() {
      this.$emit('filter', {
        mode: this.mode,
        stream_name:this.stream_name,
        start_time: this.start || null,
        end_time: this.end || null
      })
    },
    startTick() {
      this.stopTick()
      this.ticking = true
      this.timer = setInterval(() => {
        if (this.mode === 'realtime') {
          this.$emit('tick',{
            stream_name:this.stream_name,
            start_time: this.stream_start_time
          })      // 让父组件发起拉数
        }
      }, Math.max(1, this.autoInterval) * 1000)
    },
    stopTick() {
      this.ticking = false
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style scoped>
/* 页面基础 */
.page {
  min-height: 100vh;
  background: #f7f7f7;
  color: #222;
  -webkit-tap-highlight-color: transparent;
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif;
}

/* 顶部工具条 */
.toolbar {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
}
.tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}
.tab {
  flex: none;
  border: 1px solid #e5e5e5;
  background: #fafafa;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 13px;
}
.tab.active {
  border-color: #1d9bf0;
  color: #1d9bf0;
  background: #e8f3ff;
}
.realtime {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #555;
}
.realtime .dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: #bbb;
}
.realtime .dot.on { background:#16a34a; box-shadow:0 0 0 6px rgba(22,163,74,.12); }
.range {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 8px;
  align-items: center;
}
.field { display:flex; align-items:center; gap:6px; font-size:12px; color:#666; }
.field input {
  width: 100%;
  font-size: 14px;
  padding: 6px 8px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background: #fff;
}
.btn {
  padding: 7px 12px;
  border: none;
  border-radius: 8px;
  background: #1d9bf0;
  color: #fff;
  font-size: 13px;
}

/* 表格 */
.table-wrap {
  margin: 10px;
  background: #fff;
  overflow-x: auto;      /* 手机端横向滚动 */
  -webkit-overflow-scrolling: touch;
}
.table {
  width: 100%;
  border-collapse: collapse;
  min-width: 760px;      /* 确保列宽在小屏可横向滚动 */
}
thead th {
  position: sticky; top: 0;
  background: #fff;
  font-weight: 700;
  text-align: left;
  font-size: 13px;
  color: #444;
  border-bottom: 1px solid #eee;
  padding: 10px 8px;
  white-space: nowrap;
}
tbody td {
  border-bottom: 1px solid #f2f2f2;
  padding: 10px 8px;
  font-size: 13px;
  color: #333;
  vertical-align: middle;
  white-space: nowrap;
}
.cell-user .uid { font-weight: 700; }
.cell-flag i.ok { color: #16a34a; }
.cell-flag i.no { color: #ef4444; }
.empty { text-align: center; color:#888; padding: 18px 0; }

/* 横屏优化 */
@media (orientation: landscape) {
  thead th, tbody td { font-size: 14px; padding: 12px 10px; }
}

/* 大屏（Pad/桌面）稍作加强 */
@media (min-width: 1024px) {
  .table { min-width: 860px; }
}
</style>
